<form [formGroup]="inputItem" class="multiselect-list">
  <input #input [ngClass]="{'active': showList}" (click)="startComponent()" readonly formControlName="des">
  <span>
    <i [ngClass]="showList ? 'fas fa-angle-up': 'fas fa-angle-down'" (click)="showList=!showList; input.focus();"></i>
  </span>
  <content *ngIf="showList">
    <li (click)="selectUnselectAll($event)">
      <input type="checkbox" name="allElements" id="ckAll" [checked]="this.selectedAll" />
      <label for="ckAll">{{selectedAll ? ('global.multiselect.deseleccionar' | translate) : ('global.multiselect.seleccionar' | translate)}}</label>
    </li>
    <ng-container *ngFor="let item of itemsList; let i = index;">
      <li id="item{{item.id}}" tabIndex="-1" (click)="selectItem(item, $event)">
        <input type="checkbox" name="ck{{item.id}}" id="ck{{item.id}}"
          [checked]="((item.hasOwnProperty('id_aux') ? this.checkedList?.includes(item.id_aux) : this.checkedList?.includes(item.id)) ? true : false)" />
        <label for="ck{{item.id}}">{{item.des}}</label>
      </li>
    </ng-container>
    <li *ngIf="itemsList && itemsList.length === 0">{{ 'global.noContent' | translate }}</li>
  </content>
</form>